const $ = window.jQuery;

export default class Menu {
  static moveMetaToMain() {
    const $meta = $('.menu-meta-wrap');
    const $main = $('#main-nav');

    $main.append($meta);
  }
}
